module.exports = __webpack_public_path__ + "img/00003.d3cd382f.webp";